// import { useParams } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import { CardHeader, CardBody, Card, Col, Row, Button }  from "reactstrap";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ADMINTRANSACTION_DETAILS_WEBOOK } from "graphql/admin/queries/transactions";
import { SEND_TRANSACTION } from "graphql/mutations/transactions";
import { SAText } from "utils/functions";

function FixTransaction(){
  // const { tid } = useParams();
  const LZString = require('lz-string');
  
  let incomingTData = {};

  const [tdata, setTData] = useState({
    address1: "",
    address2: "",
    city: "",
    datetime: "",
    email: "",
    existingcustomer: true,
    firstname: "",
    lastname: "",
    message: "",
    paymentid: "",
    phone: "",
    price: 0,
    productid: "",
    referral: "",
    shortdescription: "",
    state: "",
    storage: 0,
    subTitle: "",
    title: "",
    zip: 0,
    ctransid: 0
  });

  try{
    const hash = window.location.hash.slice(1);
    const json = LZString.decompressFromEncodedURIComponent(hash);
    incomingTData = JSON.parse(json);
  }
  catch(e){
    console.log("Failed to decompress url string", e);
  }

  const [transactionFound, setTransactionFound] = useState(false);

  const { loading, error, data, onError, refetch } = useQuery(GET_ADMINTRANSACTION_DETAILS_WEBOOK,{
    notifyOnNetworkStatusChange: false,
    variables: ({ transactionid: incomingTData.ctransid, verification: "9091ca7a-c1c4-4db9-b873-4d0f76be8606" }),
    fetchPolicy: 'cache-and-network',
  });

  const [sendTransaction] = useMutation(SEND_TRANSACTION);

  useEffect(() => {
    const onCompleted = (data) => {
      if (data && data.lookupMissingTransactionViaWebHook.error === null){
        setTData({
          address1: data.lookupMissingTransactionViaWebHook.customer.address1,
          address2: data.lookupMissingTransactionViaWebHook.customer.address2,
          city: data.lookupMissingTransactionViaWebHook.customer.city,
          datetime: data.lookupMissingTransactionViaWebHook.transaction.datetimecreated,
          email: data.lookupMissingTransactionViaWebHook.customer.email,
          existingcustomer: true,
          firstname: data.lookupMissingTransactionViaWebHook.customer.firstname,
          lastname: data.lookupMissingTransactionViaWebHook.customer.lastname,
          message: incomingTData.message,
          paymentid: data.lookupMissingTransactionViaWebHook.transaction.gateway,
          phone: data.lookupMissingTransactionViaWebHook.customer.phone,
          price: data.lookupMissingTransactionViaWebHook.transaction.price,
          productid: data.lookupMissingTransactionViaWebHook.productid,
          referral: data.lookupMissingTransactionViaWebHook.transaction.referenceid1,
          shortdescription: data.lookupMissingTransactionViaWebHook.transaction.shortdescription,
          state: data.lookupMissingTransactionViaWebHook.customer.state,
          storage: data.lookupMissingTransactionViaWebHook.transaction.price,
          subTitle: incomingTData.subTitle,
          title: incomingTData.title,
          zip: data.lookupMissingTransactionViaWebHook.customer.zip,
          ctransid: incomingTData.ctransid
        });

        setTransactionFound(true);
      }
      else{
        setTData({
          address1: incomingTData.address1,
          address2: incomingTData.address2,
          city: incomingTData.city,
          datetime: incomingTData.datetime,
          email: incomingTData.email,
          existingcustomer: incomingTData.existingcustomer,
          firstname: incomingTData.firstname,
          lastname: incomingTData.lastname,
          message: incomingTData.message,
          paymentid: incomingTData.paymentid,
          phone: incomingTData.phone,
          price: incomingTData.price,
          productid: incomingTData.productid,//
          referral: incomingTData.referral,
          shortdescription: incomingTData.shortdescription,//
          state: incomingTData.state,
          storage: incomingTData.storage,//
          subTitle: incomingTData.subTitle,
          title: incomingTData.title,
          zip: incomingTData.zip,
          ctransid: incomingTData.ctransid
        });
      }
    };
    if (onCompleted || onError) {
      if (onCompleted && !loading && !error) {
        onCompleted(data);
      } else if (onError && !loading && error) {
        onError(error);
      }
    }
  }, [loading, data, error, onError]);

  const FixTransactionNow = () => {
    console.log("Fixing Transaction");
    
    const paymentdata = {
      firstname: tdata.firstname,
      lastname: tdata.lastname,
      address1: tdata.address1,
      address2: tdata.address2,
      city: tdata.city,
      state: tdata.state,
      zip: tdata.zip,
      phone: tdata.phone,
      email: tdata.email, 
      paymentid: tdata.paymentid,
      productid: tdata.productid,
      refid :tdata.referral,
      shortdescription: tdata.shortdescription,
      existingcustomer: tdata.existingcustomer,
      price: tdata.price,
      storage: tdata.price,
      referral: tdata.referral,
      manual_override: true
    };

    sendTransaction({ variables: { paymentdata: paymentdata, transactionid: tdata.ctransid} })
    .then( (transactionres) => {
      if(transactionres.data.sendTransaction.status){
        SAText("Success", "Transaction was successful", "success", () => {
          refetch({ transactionid: incomingTData.ctransid, verification: "9091ca7a-c1c4-4db9-b873-4d0f76be8606", awarded: true });
        });
      }
      else{
        SAText("Error", transactionres.data.sendTransaction.error, "error");
      }
    })
    .catch( (err2) => {
      SAText("Error", err2, "error");
    })
    .finally(() => {
      // setAppLoading(false);
    });
  };

  return (
    <div className="content">
    <Row>
        <Col md="12">
          {loading &&
            <h1> Loading... </h1>
          }

          {!loading &&
            <Card>
              <CardHeader className='subTitle'>Review Transaction</CardHeader>
              <CardBody>
                {transactionFound && tdata &&
                  <div>
                    <h1>Transaction Found</h1>
                  </div>
                }

                {!transactionFound && tdata &&
                  <div>
                    <h1>Transaction Missing</h1>
                      <Button
                        className="btn-fill"
                        color="info"
                        type="button"
                        onClick={
                          () => { FixTransactionNow(); }
                        }
                        >
                          Fix Transaction
                      </Button>
                      <br />
                  </div>
                }

                <div>
                  <span className='bold'>Webhook Title: </span> {tdata.title} <br />
                  <span className='bold'>Webhook SubTitle: </span> {tdata.subTitle} <br />
                  <span className='bold'>Webhook Message: </span> {tdata.message} <br />
                  <hr />

                  <span className='bold'>DateTime: </span> {tdata.datetime} <br />
                  <span className='bold'>CTransID: </span> {tdata.ctransid} <br />
                  <span className='bold'>Processor: </span> {tdata.paymentid} <br />
                  <span className='bold'>Amount: </span> {tdata.price} <br />
                  <span className='bold'>Promo Code: </span> {tdata.referral} <br />
                  <span className='bold'>First Name: </span> {tdata.firstname} <br />
                  <span className='bold'>Last Name: </span> {tdata.lastname} <br />
                  <span className='bold'>Phone: </span> {tdata.phone} <br />
                  <span className='bold'>Email: </span> {tdata.email} <br />
                  <span className='bold'>Address: </span> {tdata.address1} <br />
                  <span className='bold'>Address2: </span> {tdata.address2} <br />
                  <span className='bold'>City: </span> {tdata.city} <br />
                  <span className='bold'>State: </span> {tdata.state} <br />
                  <span className='bold'>Zip: </span> {tdata.zip} <br />
                </div>
              </CardBody>
            </Card>
          }
        </Col>
      </Row>
    </div>
  );
}

export default FixTransaction;